import request from '@/utils/request'
/**
* @fileOverview 登入注册
*/

/**
* @description 用户登入
* @param {string} data.username 用户名
* @param {string} data.password 密码
*/
export function autoLogin(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

/**
* @description 登录后初始化数据
*/
export function init() {
  return request({
    url: '/user/init',
    method: 'get'
  })
}

/**
* @description 注销用户
*/
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

/**
* @description 切换语言
* @param {string} data.lang 语言缩写，如'zh'
*/
export function choiceLanguage(data) {
  return request({
    url: '/choiceLanguage',
    method: 'post',
    data
  })
}

/**
* @description 用户注册
* @param {string} data.email 个人信息电子邮件
* @param {string} data.password 密码
* @param {string} data.password_confirmation 确认密码
* @param {string} data.firstname 名
* @param {string} data.lastname 姓
* @param {string} data.form 性别
* @param {string} data.title 头衔
* @param {string} data.position 职位
* @param {string} data.phone 手机号
* @param {string} data.young_pro 是否新秀设计师 0否 1是
* @param {string} data.images 新秀设计师需上传图片 用数组存base64 支持jpg和png
* @param {string} data.company_name 单位名称
* @param {string} data.company_ename 单位名称英文
* @param {string} data.street 地址
* @param {string} data.zip 邮政编码
* @param {string} data.city 城市
* @param {string} data.country 国家
* @param {string} data.homepage 主页网址
* @param {string} data.address_phone 工作电话
* @param {string} data.address_email 邮箱
* @param {string} data.address_fax 传真
* @param {string} data.type (1-短信验证 2-邮箱验证）
* @param {string} data.code 四位验证码
* @param {string} data.participant_type 参赛者身份
* @param {string} data.identity_type 身份类型
* @param {string} data.identificationNumber 证件号码
* @param {string} data.region 区域
*/
export function register(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

/**
* @description 修改密码
* @param {string} data.old_password 原密码
* @param {string} data.password 新密码
* @param {string} data.password_confirmation 确认密码
*/
export function changePassword(data) {
  return request({
    url: '/user/changePassword',
    method: 'patch',
    data
  })
}

/**
* @description 找回密码
* @param {string} data.email   验证邮箱时必填
* @param {string} data.phone   验证手机号时必填
* @param {string} data.code    验证码必填四位
* @param {string} data.type    （1-短信验证 2-邮箱验证）
* @param {string} data.password 新密码
* @param {string} data.password_confirmation 确认密码
*/
export function userFindPassword(data) {
  return request({
    url: '/user/findPassword',
    method: 'post',
    data
  })
}

/**
* @description 发送邮箱验证码
* @param {string} data.email 邮箱
* @param {string} data.type 1注册时，2找回密码
*/
export function mailCode(data) {
  return request({
    url: '/mail/code',
    method: 'post',
    data
  })
}

/**
* @description 发送短信验证码
* @param {string} data.phone 手机号
* @param {string} data.type 1注册时，2找回密码
*/
export function userSendCode(data) {
  return request({
    url: '/user/sendCode',
    method: 'post',
    data
  })
}

